import React, { useState, useEffect } from "react";
import SmartQuestionaireStepWizard from "./SmartQuestionaireStepWizard";
import SmartQuestionaireStep1 from "./SmartQuestionaireStep1";
import SmartQuestionaireStep2 from "./SmartQuestionaireStep2";
import { getEnvelopeSenderList, getSmartQuestionaireDetails } from "../../../services/CommonService";
import { toast } from "react-toastify";
import Utils from "../../../utils";
import { useParams } from 'react-router-dom';

function SmartQuestionaire() {
  const [loading, setLoading] = useState(false);
  const [senderList, setSenderList] = useState([]);
  const [isCall, setIsCall] = useState(false);
  const { uuid, id, direct } = useParams();

  let formData = {
    current_step: (id) ? parseInt(id) : 1,
    smart_questionaire_id: 0,
    smart_questionaire_uuid: '',
    sender_id: 0,
    smart_form_name: '',
    due_date: '',
    recipient_list: [],
    is_done: false,
    is_use: false
  };
  const [formObj, setFormObj] = useState(formData);

  useEffect(() => {
    getEnvelopeSenderList()
      .then(response => {
        setSenderList(response.data.data);
      })
      .catch(err => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(() => {
    // If uuid is present, fetch details and set formObj
    if (uuid) {
      setLoading(true);
      getSmartQuestionaireDetails({ sleeve_uuid: uuid })
        .then(res => {
          const data = res.data.data;
          if (data) {
            // Transform recipients to match Step1 expected format
            const transformedRecipients = (data.recipients || []).map(recipient => {
              const nameParts = recipient.recipient_name.split(' ');
              return {
                id: recipient.recipient_id,
                first_name: nameParts[0] || '',
                last_name: nameParts.slice(1).join(' ') || '',
                email: recipient.recipient_email,
                recipient_id: recipient.recipient_id,
                recipient_name: recipient.recipient_name,
                recipient_email: recipient.recipient_email
              };
            });

            setFormObj({
              current_step: (id) ? parseInt(id) : 1,
              smart_questionaire_id: data.sleeve_id || 0,
              smart_questionaire_uuid: data.sleeve_uuid || '',
              sender_id: data.sender_id || 0,
              smart_form_name: data.sleeve_name || '',
              due_date: data.due_date || '',
              recipient_list: transformedRecipients,
              recipients: data.recipients || [],
              sleeve_id: data.sleeve_id || 0,
              created_at: data.created_at || '',
              is_done: false,
              is_use: !!direct
            });
          }
          setLoading(false);
        })
        .catch(() => {
          setFormObj(formData);
          setLoading(false);
        });
    } else {
      setFormObj(formData);
    }
  }, [uuid, id, direct]);

  const renderStep = (step) => {
    if (parseInt(step) === 1) {
      return <SmartQuestionaireStep1
        senderList={senderList}
        formObj={formObj}
        setFormObj={setFormObj}
        setLoading={setLoading}
        loading={loading}
      />
    } else if (parseInt(step) === 2) {
      return <SmartQuestionaireStep2
        formObj={formObj}
        setFormObj={setFormObj}
        setLoading={setLoading}
        loading={loading}
      />
    }
  };

  return (
    <>
      {loading && <div className="page-loading">
        <img src="/images/loader.gif" alt="loader" />
      </div>}
      <section className="main_wrapper section-bg-color detail_page setting_tab mx-auto" style={{ minHeight: 'calc(100vh - 54.5px)' }}>
        <SmartQuestionaireStepWizard step={formObj.current_step} isDone={formObj.is_done} loading={loading} />
        {renderStep(formObj.current_step)}
      </section>
    </>
  );
}

export default SmartQuestionaire;